import { dateFormat } from './dates'
import { filterObject, serialize } from './objects'

const currentPage = location.pathname

const queryString = filters => {
    for(let filter in filters) {
        if(filters[filter] instanceof Date) {
            filters[filter] = dateFormat(filters[filter], 'Y-m-d')
        }

        if(Array.isArray(filters[filter])) {
            filters[filter] = filters[filter].map(item => item.id).join(',')
        }
    }

    const active_filters = filterObject(filters, filter => {
        return filter
    })

    return serialize(active_filters)
}

export {
    currentPage,
    queryString,
}
